__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['one-identity-root'].baseUrl;
import 'react-simple-keyboard/build/css/index.css';
import RootModule from './components/IdentityRoot';
import './global.scss';
import { configureIguazuProcedures } from './procedures';
import { configureProducts } from './products';
import { configureIguazuResources } from './resources';
configureIguazuProcedures();
configureIguazuResources();
configureProducts();
if (!global.BROWSER) {
  // Increase the stack trace limit for errors thrown on the server.
  Error.stackTraceLimit = 20;
  // eslint-disable-next-line global-require -- server-side require
  RootModule.appConfig = require('./appConfig').default;
}
export default RootModule;
;
if (!global.BROWSER) {
  RootModule.appConfig = Object.assign({}, RootModule.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
RootModule.appConfig = Object.assign({}, RootModule.appConfig, {
  providedExternals: {
    '@americanexpress/one-identity-ducks': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '9.9.0',
      module: require('@americanexpress/one-identity-ducks')
    },
    '@americanexpress/data-manager-utils': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.2',
      module: require('@americanexpress/data-manager-utils')
    },
    '@americanexpress/browser-performance-mark': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.0.0',
      module: require('@americanexpress/browser-performance-mark')
    },
    '@americanexpress/myca-essentials': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.1.1',
      module: require('@americanexpress/myca-essentials')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    },
    '@americanexpress/product-ducks': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.3.3',
      module: require('@americanexpress/product-ducks')
    },
    'iguazu': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.2.0',
      module: require('iguazu')
    },
    'iguazu-rest': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.11.1',
      module: require('iguazu-rest')
    },
    'iguazu-rpc': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.1',
      module: require('iguazu-rpc')
    },
    'react-intl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '5.25.1',
      module: require('react-intl')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'one-identity-root') {
  global.getTenantRootModule = () => RootModule;
  global.rootModuleName = 'one-identity-root';
}